import { ContactUsModel } from '../../interfaces/ContactUs.model';
import axios from '../../utils/axios';

/**
 * contact us
 */
export const contactUs = async (payload: ContactUsModel) =>
  await axios.post('account/contactUs', payload);
